'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_patterns_ZapierLogoSymbol_svgs_Styles = require('./Styles.cjs.js');

const SymbolSize30 = () => {
  return react.jsx(
    "svg",
    { css: components_patterns_ZapierLogoSymbol_svgs_Styles.Styles.root, width: "30", height: "30", "data-testid": "ZapierLogoSymbolSmall", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react.jsx("rect", { width: "30", height: "30", rx: "5", fill: "#FF4F00" })
  );
};

exports.SymbolSize30 = SymbolSize30;
//# sourceMappingURL=SymbolSize30.cjs.js.map
